{
	"title": "Omzet",
	"back": "Start",
	"description": "Wat betaald is of op rekening staat, exclusief btw. Refunds en geannuleerde bestellingen op rekening gaan eraf op de dag van de creditfactuur.",
	"range": {
		"label": "Periode",
		"today": "Vandaag",
		"week": "Deze week",
		"month": "Deze maand",
		"year": "Dit jaar",
		"from": "Van",
		"to": "Tot en met"
	},
	"total": "Totaal",
	"consumer": "Particulier",
	"business": "Zakelijk",
	"shipping": "Waarvan verzendkosten",
	"exclVat": "Alle bedragen exclusief btw.",
	"perDay": "Per dag",
	"perProduct": "Per product",
	"dayTable": "Per dag als tabel",
	"shippingLine": "Verzendkosten",
	"empty": "Geen omzet in deze periode.",
	"column": {
		"date": "Datum",
		"product": "Product",
		"shipping": "Verzendkosten"
	},
	"chart": {
		"label": "Omzet per dag",
		"legend": "Legenda",
		"hint": "Wijs een dag aan (of gebruik de pijltjestoetsen in de grafiek) voor de bedragen.",
		"day": "{{date}}: {{total}} (particulier {{consumer}}, zakelijk {{business}})",
		"summary": "Omzet per dag over {{days}} dagen",
		"description": "Gestapelde staven per dag: particulier onder, zakelijk erboven, exclusief btw. Een dag met meer terugbetaald of gecrediteerd dan verkocht staat onder de nullijn."
	},
	"help": {
		"revenue": {
			"title": "Omzet",
			"area": "Omzet",
			"short": "Wat er verdiend is in een periode, zonder btw. Een betaalde order telt op de dag van betaling en een order op rekening op de factuurdatum; een terugbetaling of creditfactuur gaat eraf op haar eigen dag.",
			"terms": [
				"revenue:period",
				"revenue:counts",
				"revenue:segments",
				"revenue:perDay",
				"revenue:perProduct"
			]
		},
		"period": {
			"title": "Periode",
			"area": "Omzet › Periode",
			"short": "Kies vandaag, deze week, deze maand of dit jaar, of vul zelf twee datums in. Zonder keuze zie je deze maand. De dagen lopen van middernacht tot middernacht, Nederlandse tijd.",
			"choices": [
				{
					"name": "Deze week",
					"text": "Vanaf maandag tot en met vandaag."
				},
				{
					"name": "Deze maand",
					"text": "Vanaf de 1e tot en met vandaag."
				},
				{
					"name": "Dit jaar",
					"text": "Vanaf 1 januari tot en met vandaag."
				},
				{
					"name": "Van en Tot en met",
					"text": "Een eigen periode; beide dagen tellen mee."
				}
			]
		},
		"counts": {
			"title": "Wat meetelt",
			"area": "Omzet",
			"short": "Een betaalde order telt op de dag van betaling, een order op rekening op de factuurdatum. Een open of verlopen order telt niet. Alle bedragen zijn zonder btw en na korting, met de verzendkosten apart.",
			"warning": "Een terugbetaling gaat eraf op de dag van de terugbetaling, niet op de dag van de order. Zo kan een dag onder nul uitkomen. Een geannuleerde order op rekening gaat eraf op de datum van de creditfactuur.",
			"terms": ["order:paymentStatus", "order:order"]
		},
		"segments": {
			"title": "Particulier en zakelijk",
			"area": "Omzet",
			"short": "Een order telt zoals hij belast is. Bestelde de klant als zakelijke klant, ook met btw verlegd, dan is het zakelijk; anders particulier. Een gast is particulier.",
			"warning": "Het telt zoals het was bij het bestellen. Wordt een klant later zakelijk, dan blijven zijn oude orders particulier."
		},
		"perDay": {
			"title": "Per dag",
			"area": "Omzet › Per dag",
			"short": "Een staaf per dag: particulier onder, zakelijk erboven. Wijs een dag aan voor de bedragen. Staat een staaf onder de nullijn, dan is er die dag meer terugbetaald of gecrediteerd dan verkocht.",
			"terms": ["revenue:counts"]
		},
		"perProduct": {
			"title": "Per product",
			"area": "Omzet › Per product",
			"short": "De omzet per product in de periode, particulier en zakelijk apart, de grootste eerst. De verzendkosten staan op een eigen regel. Klik op een product om het te openen.",
			"terms": ["revenue:segments"]
		}
	}
}
